import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { PREFIX_FIELD_LABEL, PREFIX_INVALID_MESSAGE } from '../constants';

/** 默认配置 */
export var TranslateInvalidDefaultOptions = {
  /** 原因前缀 */
  reasonPrefix: PREFIX_INVALID_MESSAGE,

  /** 表单项前缀 */
  fieldPrefix: PREFIX_FIELD_LABEL
};
/** 翻译错误信息 */

export var translateInvalid = function translateInvalid(name, invalid, t) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var noNullOptions = _typeof(options) === 'object' ? options : {};

  var _Object$assign = Object.assign({}, TranslateInvalidDefaultOptions, noNullOptions),
      reasonPrefix = _Object$assign.reasonPrefix,
      fieldPrefix = _Object$assign.fieldPrefix;

  if (Array.isArray(invalid) && invalid.length > 0) {
    var _invalid = _slicedToArray(invalid, 2),
        reason = _invalid[0],
        _data = _invalid[1];

    if (typeof reason === 'string') {
      var upName = name.replace(/([A-Z])/g, '_$1').toUpperCase();
      var upReason = reason.replace(/([A-Z])/g, '_$1').toUpperCase();
      var field = "".concat(fieldPrefix).concat(upName);
      var fieldReason = "".concat(reasonPrefix).concat(upReason, "_").concat(upName);
      var fieldDefaultReason = "".concat(reasonPrefix).concat(upReason);
      var message = t(fieldReason, _objectSpread({
        field: field
      }, _data));
      return message === fieldReason ? t(fieldDefaultReason, _objectSpread({
        field: field
      }, _data)) : message;
    }
  }

  return '';
};